import React, { useEffect, useRef } from 'react';
import { marked } from 'marked';
import { formatFiscalDateFromString } from '../../utils/commonUtils';
import ComparingGraph from './ComparingGraph';
import { formatDateTimeString } from '../../utils/commonUtils'
import Loading from '../../Loading';


const FinancialResultsSummary = ({ financialSummary, financialData, quarterlyFinancialData, selectedPeriod }) => {
    const data = selectedPeriod === "annual" ? financialData : quarterlyFinancialData;
    const extractSummaryAndDetail = (contents) => {
        // "###"で分割
        const sections = contents.split("###");

        // 1つ目と2つ目の"###"の間の部分をsummaryとして取得
        const summary = sections.length > 1 ? `###${sections[1]}` : '';

        // 2つ目の"###"以降をdetailとして取得
        const detail = sections.length > 2 ? `###${sections.slice(2).join('###')}` : '';

        return { summary, detail };
    }

    if (!data || !financialSummary) {
        return <Loading />
    }
    
    if (!Object.keys(financialSummary?.doc_info).length) {
        return <div>申し訳ございませんが、米国企業の AI 決算サマリは準備中です。もう少しだけお待ちください。</div>
    }

    const { summary, detail } = extractSummaryAndDetail(financialSummary.daily_report.contents);
    const htmlSummary = marked(summary);
    const htmlDetail = marked(detail);

    const getTitle = () => {
        if (selectedPeriod === 'annual') {
            return formatFiscalDateFromString(financialSummary.doc_info.fiscal_year_end) + " 通期決算"
        } else {
            const toTermName = {
                '1q': '第1四半期',
                '2q': '第2四半期',
                '3q': '第3四半期',
                '4q': '第4四半期',
                '5q': '第4四半期',
            }

            const term = financialSummary.doc_info.term;
            return formatFiscalDateFromString(financialSummary.doc_info.fiscal_year_end) + ' ' + toTermName[term];
        }
    }

    return (
        <>
            <h3>{getTitle()}</h3>
            <div className='tanshin-filing-date'>{formatDateTimeString(financialSummary.doc_info.filing_date, "YYYY年m月d日")} 公表</div>
            <div className="financial-summary">
                <div className="tanshin-financial-summary tanshin-summary-block">
                    <div
                        className="tanshin-financial-summary"
                        dangerouslySetInnerHTML={{ __html: htmlSummary }}
                    ></div>
                    {data.length > 0 &&

                        <div className="dashboard-graphs tanshin-summary-block">
                            <ComparingGraph financialData={data} title="売上高" column="sales" selectedPeriod={selectedPeriod} />
                            <ComparingGraph financialData={data} title="営業利益" column="operating_income" selectedPeriod={selectedPeriod} />
                            <ComparingGraph financialData={data} title="当期利益" column="net_income" selectedPeriod={selectedPeriod} />
                        </div>
                    }
                    {/* 詳細部分 */}
                    <div
                        className="tanshin-financial-details"
                        dangerouslySetInnerHTML={{ __html: htmlDetail }}
                    ></div>
                </div>
            </div>
        </>
    );
};

export default FinancialResultsSummary;
